import React, { useEffect, useState } from 'react';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import FullScreen from '../icons/FullScreen';
import LeftArrow from '../icons/LeftArrow';
import RightArrow from '../icons/RightArrow';
import PageList from '../icons/PageList';

const useFullScreenPDFReader = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>();
  const [isFullScreenMode, setIsFullScreenMode] = useState(false);
  const [isDocumentLoaded, setIsDocumentLoaded] = useState(false);

  const PageNumberButton = (props) => {
    useEffect(() => {
      setTotalPages(props.numberOfPages);
      setCurrentPage(props.currentPage + 1);
    }, [props]);

    return (
      <div
        style={{
          padding: '10px 15px',
        }}
        className="background-white black-border-1 border-radius-7 d-flex justify-center align-items-center gap-10"
      >
        {isFullScreenMode && <PageList />}
        <div>
          Page{' '}
          <b>
            {props.currentPage + 1} / {props.numberOfPages}
          </b>
        </div>
      </div>
    );
  };

  const ToolbarComponent = (slots) => {
    const {
      EnterFullScreen,
      GoToNextPage,
      GoToPreviousPage,
      CurrentPageLabel,
    } = slots;

    return (
      <div className="w-100 d-flex justify-end align-items-center">
        {isFullScreenMode ? (
          <div className="d-none">
            <CurrentPageLabel>
              {(props) => <PageNumberButton {...props} />}
            </CurrentPageLabel>
          </div>
        ) : (
          <>
            <div className="right-25 zIndex-1 position-absolute top-10">
              <EnterFullScreen>
                {() => (
                  <FullScreen
                    onClick={() => {
                      setIsFullScreenMode(true);
                      setIsDocumentLoaded(false);
                    }}
                  />
                )}
              </EnterFullScreen>
            </div>
            <div
              style={{
                padding: '0px 2px',
                margin: '0 14px',
              }}
              className="d-flex align-items-center space-between w-100"
            >
              <GoToPreviousPage>
                {(props) => (
                  <div
                    style={{
                      padding: '10px 12px',
                      opacity: currentPage === 1 ? 0.5 : 1,
                    }}
                    className="black-border-1 border-radius-4"
                    onClick={props.onClick}
                  >
                    <LeftArrow />
                  </div>
                )}
              </GoToPreviousPage>
              <CurrentPageLabel>
                {(props) => <PageNumberButton {...props} />}
              </CurrentPageLabel>
              <GoToNextPage>
                {(props) => (
                  <div
                    style={{
                      padding: '10px 12px',
                      opacity: currentPage === totalPages ? 0.5 : 1,
                    }}
                    className="black-border-1 border-radius-4"
                    onClick={props.onClick}
                  >
                    <RightArrow />
                  </div>
                )}
              </GoToNextPage>
            </div>
          </>
        )}
      </div>
    );
  };

  const renderToolbar = (Toolbar) => {
    return <Toolbar>{(slots) => <ToolbarComponent {...slots} />}</Toolbar>;
  };

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar,
    sidebarTabs: () => [],
  });

  return {
    defaultLayoutPluginInstance,
    isFullScreenMode,
    currentPage,
    totalPages,
    setIsFullScreenMode,
    isDocumentLoaded,
    setIsDocumentLoaded,
  };
};

export default useFullScreenPDFReader;
